import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MdbTooltipModule, MdbRippleModule],
  selector: 'mapfre-tooltip-old',
  templateUrl: './mapfre-tooltip.component.html'
})
export class MapfreTooltipComponent {
  @Input() additionalClasses:     string;
  @Input() linkCopy:              string;
  @Input() toolTipPlacement:      string;
  @Input() typeOfToolTip:         string;


}
